import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
} from '../../../utils/helpers/model.helper';

export const BILLED_DOCUMENT_SCHEMA = Object.freeze({
  TYPE: '', // e.g. invoice
  ID: '', // guid
  REVISION_ID: '',
  ADDED_DATE: null, // i2g-date-time (yyyy-mm-dd'T'hh:mm:ssZ)
  UPDATED_DATE: null, // i2g-date-time (yyyy-mm-dd'T'hh:mm:ssZ)
});
const RECORD = generateSchema(BILLED_DOCUMENT_SCHEMA);
const KEYS: any = generateKeys(BILLED_DOCUMENT_SCHEMA);

export class BilledDocument extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get type(): string {
    return this.get(KEYS.TYPE);
  }

  get id(): string {
    return this.get(KEYS.ID);
  }

  get revisionId(): string {
    return this.get(KEYS.REVISION_ID);
  }

  get addedDate(): string {
    return this.get(KEYS.ADDED_DATE);
  }

  get updatedDate(): string {
    return this.get(KEYS.UPDATED_DATE);
  }
}
